import React from 'react';
import { useGetOne } from 'react-admin';
import TextField from '@material-ui/core/TextField';

/**
 * Read-only display of the advertiser-level platform margin on forms that
 * reference an advertiser (e.g. the campaign form). The margin is stored on
 * the advertiser doc only and applies to all of that advertiser's campaigns
 * at serve time, so this is informational — edit it on the Advertiser form.
 * Caller is responsible for role-gating (see isAdminRole in utils.js).
 */
const AdvertiserMarginField = ({ advertiserId, style }) => {
  const { data, loading } = useGetOne('advertisers', advertiserId);
  const pct = data && Number(data.platform_margin_pct) > 0 ? Number(data.platform_margin_pct) : 0;
  // variant/margin match react-admin's filled dense inputs so this sits
  // flush beside NumberInput fields (plain MUI defaults look unstyled).
  return (
    <TextField
      label="Platform Margin (%)"
      value={loading ? '' : pct}
      disabled
      variant="filled"
      margin="dense"
      style={style}
      InputLabelProps={{ shrink: true }}
      helperText="Set on the advertiser. Payout = gross x (1 - margin)."
    />
  );
};

export default AdvertiserMarginField;
